const types = {
    NEWS_REQUEST: 'news/NEWS_REQUEST',
    NEWS_REQUEST_COMPLETED: 'news/NEWS_REQUEST_COMPLETED',
    NEWS_DETAIL_REQUEST: 'news/NEWS_DETAIL_REQUEST',
    NEWS_DETAIL_REQUEST_COMPLETED: 'news/NEWS_DETAIL_REQUEST_COMPLETED',
};

const createTypes = {
    ADD_NEWS_REQUEST: 'news/ADD_NEWS_REQUEST',
};

const updateTypes = {
    UPDATE_NEWS_REQUEST: 'news/UPDATE_NEWS_REQUEST',
};

const deleteTypes = {
    DELETE_NEWS_REQUEST: 'news/DELETE_NEWS_REQUEST',
    DELETE_NEWS_REQUEST_COMPLETED: 'news/DELETE_NEWS_REQUEST_COMPLETED',
};

export default {
    ...types,
    ...createTypes,
    ...updateTypes,
    ...deleteTypes,
};
